// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2d031cc9","64":"78b2f34a","605":"12e1abc6"}[chunkId] + ".chunk.js";
};